// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltipItem_tooltip__mV7Uo","tooltipSource":"tooltipItem_tooltipSource__seEOw"};